import { forwardRef, type PropsWithChildren } from "react";

import { Button, type ButtonProps } from "./button";

export const AlertButton = forwardRef<
  HTMLButtonElement,
  PropsWithChildren<Omit<ButtonProps, "variant">>
>(({ children, ...props }, ref) => {
  return (
    <Button ref={ref} variant="alert" {...props}>
      {children}
    </Button>
  );
});
